import moment from 'moment';

const daysToDate = date => moment(date).diff(moment(), 'days')

const daysFromDate = date => moment().diff(moment(date), 'days')

const dateStatus = date => {
  const diff = daysToDate(date)
  if (diff < 1) return 'expired'
  if (diff < 30) return 'expiring'
  return 'valid'
}

export {
  dateStatus,
  daysToDate,
  daysFromDate
}



// WEBPACK FOOTER //
// ./src/date-helpers.js